import { Injectable } from '@angular/core';
import { Order } from '@classes/order/order';

@Injectable({
  providedIn: 'root'
})
export class MWorkerService {

  private readonly _baseUrl = 'https://basic.m-worker.com/status/vehicles/overview/';

  constructor() { }
  public openOrderInMworker(order: Order): void {
    if (this.canGenerateLink(order)) {
      const link = this._generateLink(order);

      this._openLinkInNewWindow(link);
    }
  }

  public canGenerateLink(order: Order): boolean {
    return (order.vehicle && order.vehicle.internalId) && order.startedOn !== undefined;
  }

  private _generateLink(order: Order): string {
    const { internalId } = order.vehicle;
    const { startedOn } = order;
    let endDate: Date | string = order.receivers[order.receivers.length - 1]?.completedOn;

    if (!endDate) {
      const day = new Date();
      endDate = day.toISOString();
    }

    return `${this._baseUrl}${internalId}/history?fromDatetime=${startedOn}&toDatetime=${endDate}`;
  }

  private _openLinkInNewWindow(link: string): void {
    const width = window.innerWidth;
    const height = window.innerHeight;

    window.open(link, '_blank', `width=${width}, height=${height}`);
  }
}
